var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStemArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.154 0.92334L18.8719 8.59895C19.076 8.77895 19.2395 9.00032 19.3514 9.24835C19.4634 9.49639 19.5213 9.76541 19.5213 10.0375C19.5213 10.3097 19.4634 10.5787 19.3514 10.8267C19.2395 11.0748 19.076 11.2961 18.8719 11.4761L10.1538 19.1504L8.50199 17.2739L15.3026 11.2875H0.875V8.78746H15.3028L8.50198 2.79971L10.154 0.92334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStemArrowRight);
export default __webpack_public_path__ + "static/media/stem-arrow-right.97f5d600.svg";
export { ForwardRef as ReactComponent };